import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDownload01Alt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.226 14.469c-.173-.173-.26-.26-.36-.322a1 1 0 0 0-.29-.12C6.463 14 6.34 14 6.096 14h-.762c-.305 0-.567 0-.802.037a3 3 0 0 0-2.494 2.494 5.274 5.274 0 0 0-.037.802v.15c0 .476 0 .83.05 1.143a4 4 0 0 0 3.324 3.325c.313.05.667.05 1.143.05h10.966c.476 0 .83 0 1.143-.05a4 4 0 0 0 3.325-3.325c.05-.313.05-.666.049-1.143v-.15c0-.305 0-.567-.037-.802a3 3 0 0 0-2.494-2.494 5.278 5.278 0 0 0-.802-.037h-.762c-.244 0-.367 0-.482.028a1 1 0 0 0-.289.12c-.1.061-.187.148-.36.32l-2.653 2.653a3 3 0 0 1-4.242 0L7.226 14.47Z"
    />
    <path
      fill="currentColor"
      d="M13 3a1 1 0 1 0-2 0v9.586L7.707 9.293a1 1 0 0 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L13 12.586V3Z"
    />
  </svg>
);
SvgDownload01Alt.displayName = 'Download01Alt';
export default SvgDownload01Alt;
